import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

import { TReturnedFileData } from '@shared/services/bots/types/types';

import { PreviewModalComponent } from '../preview-modal/preview-modal.component';

@Component({
    selector: 'app-file-preview-modal',
    templateUrl: './file-preview-modal.component.html',
    styleUrls: ['./file-preview-modal.component.scss'],
    standalone: true,
    imports: [MatIcon],
})
export class FilePreviewModalComponent {
  @Input() file: TReturnedFileData | undefined;

  constructor(private _dialog: MatDialog) {}

  openModal() {
    this._dialog.open(PreviewModalComponent, {
      width: '90vw',
      data: {
        filename: this.file?.name,
      },
    });
  }
}
